"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordIpRefundSchema = void 0;
const zod_1 = require("zod");
/** IP manual refund contract — desk, 2026-09-24. */
exports.recordIpRefundSchema = zod_1.z.object({
    /** Integer paise, positive. The server re-checks this against the LIVE refundable balance regardless. */
    amount: zod_1.z.number().int().positive(),
    mode: zod_1.z.string().min(1).max(50),
    remarks: zod_1.z.string().max(1000).optional(),
});
//# sourceMappingURL=ip-refund.schema.js.map